import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { contentContainerStyle } from '@/components/ui/Layout/ContentContainer/style';
/**
 * コンテンツ幅を制御するためのコンポーネント
 * @param props
 * @constructor
 */
export const ContentContainer = (props) => {
    const { children, className = '', isMinWidthFull, maxWidthPoint } = props;
    const style = contentContainerStyle({
        class: className,
        isMinWidthFull,
        maxWidthPoint,
    });
    return _jsx("div", Object.assign({ className: style }, { children: children }));
};
